import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { ButtonProps } from 'antd/es/button';
import React, { forwardRef } from 'react';

export interface WrapperButtonProps extends ButtonProps {
  icon?: React.ReactNode;
  label?: string;
  buttonType?: 'primary' | 'default' | 'action' | 'danger' | 'custom';
}

const WrapperButton = forwardRef<HTMLButtonElement, WrapperButtonProps>(
  ({ icon, label, buttonType = 'default', style, ...rest }, ref) => {
    const mergedStyle = { ...style };

    return (
      <Button
        ref={ref}
        {...rest}
         className={
          buttonType === 'custom' 
            ? `${rest.className ?? ''}`
            : `wp-btn wp-btn-${buttonType} ${rest.className ?? ''}`
        }
        style={mergedStyle} // style truyền vào sẽ override class
        icon={icon}
      >
        {label}
      </Button>
    );
  }
);

WrapperButton.displayName = 'WrapperButton';

export default WrapperButton;

export const TableDeleteButton = (props: ButtonProps) => {
  return <WrapperButton {...props} label='Xóa' buttonType='danger' icon={<DeleteOutlined />} data-action="delete" />;
};

export const TableViewButton = (props: ButtonProps) => {
  return <WrapperButton {...props} label='Xem' buttonType='primary' icon={<EyeOutlined />} />;
};

export const TableEditButton = (props: ButtonProps) => {
  return <WrapperButton {...props} label='Sửa' buttonType='primary' icon={<EditOutlined />} />;
};
